export default __webpack_public_path__ + "static/media/base-apparel.51566e7f.png";